import React, { useCallback, useState } from 'react'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import { useStyles } from './styles'
import { isMobile } from 'src/utils/isMobile'
import { Loading } from 'src/components'

import {
  GeneralInformations,
  MovementRecord,
  HealthControl,
  GeneticEvaluation,
  ProductiveHistory,
  Genealogy,
  Gallery
} from '../../views'
import { ReproductiveHistory } from '../../views/ReproductiveHistory'
import { IAnimal } from 'src/dto/animal.dto'

export type Tabs =
  | 'informacoes-gerais'
  | 'registro-movimentacoes'
  | 'controle-sanitario'
  | 'avaliacao-genetica'
  | 'historico-produtivo'
  | 'historico-reproducao'
  | 'galeria'

const tabsData = [
  { label: 'Informações Gerais', slug: 'informacoes-gerais' },
  { label: 'Registro de movimentações', slug: 'registro-movimentacoes' },
  { label: 'Histórico de Reprodução', slug: 'historico-reproducao' },
  { label: 'Controle Sanitário', slug: 'controle-sanitario' },
  // { label: 'Avaliação Genética', slug: 'avaliacao-genetica' },
  { label: 'Histórico Produtivo', slug: 'historico-produtivo' },
  { label: 'Galeria', slug: 'galeria' }
]

interface ITabsNavigation {
  handleCloseModal: () => void
  aimalData?: IAnimal
  isLoading?: boolean
}

export default function TabsNavigation({ aimalData, isLoading, handleCloseModal }: ITabsNavigation) {
  const [genealogyPageIsActive, setGenealogyPageIsActive] = useState(false)
  const [tabActive, setTabActive] = useState<Tabs>('informacoes-gerais')

  const styles = useStyles()

  const handleChange = useCallback((event: React.ChangeEvent<{}>, activeTab: Tabs) => {
    setTabActive(activeTab)
  }, [])

  const renderTabContent = () => {
    if (isLoading) {
      return (
        <div className={styles.loadingContainer}>
          <Loading />
        </div>
      )
    }

    switch (tabActive) {
      case 'informacoes-gerais':
        return (
          <GeneralInformations
            data={aimalData}
            openGeneologyTree={() => setGenealogyPageIsActive(true)}
            onCloseModal={handleCloseModal}
          />
        )

      case 'registro-movimentacoes':
        return <MovementRecord data={aimalData} />

      case 'controle-sanitario':
        return <HealthControl data={aimalData} />

      case 'avaliacao-genetica':
        return <GeneticEvaluation data={aimalData} />

      case 'historico-produtivo':
        return <ProductiveHistory data={aimalData} />

      case 'historico-produtivo':
        return <ProductiveHistory data={aimalData} />

      case 'historico-reproducao':
        return <ReproductiveHistory data={aimalData} />

      case 'galeria':
        return <Gallery data={aimalData} />

      default:
        return null
    }
  }

  return (
    <>
      {genealogyPageIsActive ? (
        <Genealogy
          dataAnimal={aimalData!}
          closeGeneologyTree={() => setGenealogyPageIsActive(false)}
          closeModalDetail={handleCloseModal}
        />
      ) : (
        <>
          <div className={styles.tabsNavigationsContainer}>
            <Tabs
              value={tabActive}
              onChange={handleChange}
              indicatorColor='primary'
              textColor='primary'
              scrollButtons={isMobile() ? 'off' : 'on'}
              variant='scrollable'
            >
              {tabsData.map((tab) => (
                <Tab key={tab.slug} label={tab.label} value={tab.slug} />
              ))}
            </Tabs>
          </div>
          <div className={styles.viewContainer}>{renderTabContent()}</div>
        </>
      )}
    </>
  )
}
